import { z } from 'zod';
import { RISK_LEVELS, SPECIALTIES } from '../constants/index.js';

const riskEnum = z.enum(RISK_LEVELS);
const specialtyEnum = z.enum(SPECIALTIES);

export const aiClauseAnalysisSchema = z.object({
  id: z.string(),
  title: z.string(),
  text: z.string(),
  riskLevel: riskEnum,
  concerns: z.array(z.string()),
  suggestions: z.array(z.string()),
});

export const aiContractAnalysisSchema = z.object({
  summary: z.string(),
  contractType: z.string(),
  parties: z.array(z.string()),
  clauses: z.array(aiClauseAnalysisSchema),
  overallRisk: riskEnum,
  recommendedSpecialty: specialtyEnum,
});

export type AIClauseAnalysis = z.infer<typeof aiClauseAnalysisSchema>;
export type AIContractAnalysis = z.infer<typeof aiContractAnalysisSchema>;
